import React from 'react'

type ProviderFC = React.FC<React.PropsWithChildren>

export const CombineProviders = (providers: ProviderFC[]): ProviderFC => {
  return providers.reduce(
    (AccumulatedProviders, CurrentProvider) => {
      return Object.assign(
        ({ children }: React.PropsWithChildren): JSX.Element => {
          return (
            <AccumulatedProviders>
              <CurrentProvider>{children}</CurrentProvider>
            </AccumulatedProviders>
          )
        },
        { displayName: 'CombineProviders' }
      )
    },
    ({ children }) => <>{children}</>
  )
}
